import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export interface NotifyUserDto {
    title: string;
    body: string;
    url?: string;
    data?: Record<string, any>;
}

export function useNotifyUser(userId: string) {
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async (dto: NotifyUserDto) => {
            const response = await apiClient.fetchApi<NotifyUserDto, {}>({ 
                method: 'POST', 
                endpoint: `users/${userId}/notify`,
                body: dto,
            });
            return response;
        },
        onSuccess: () => {
            // Invalidate user data to refresh notifications if needed
            queryClient.invalidateQueries({ queryKey: ['user', userId] });
        },
    });
}
